import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './CandidateRegister.module.css';

const ROLES = [
  { value: 'RSM', label: 'Regional Sales Manager (RSM)' },
  { value: 'FSM', label: 'Field Sales Manager (FSM)' },
  { value: 'TSE', label: 'Territory Sales Manager (TSE)' },
];

export default function CandidateRegister() {
  const { candidate, updateCandidate } = useAuth();
  const [confirmed, setConfirmed] = useState(false);
  const navigate = useNavigate();
  
  const displayRole = ROLES.find(r => r.value === candidate?.role)?.label || candidate?.role;

  // Prevent browser back button from working
  useEffect(() => {
    // Push a dummy state to the history stack
    window.history.pushState(null, null, window.location.href);

    const handlePopState = () => {
      // Push again to prevent actual back navigation
      window.history.pushState(null, null, window.location.href);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const handleNext = () => {
    updateCandidate({ role: candidate?.role });
    navigate('/welcome', { replace: true });
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.topBar}>
          <div className={styles.logoRow}>
            <img src="/logo.png" alt="UAC Foods Logo" className={styles.logoMark} />
            <span className={styles.logoText}>UAC Foods — Sales Leadership Assessment</span>
          </div>
        </div>

        <div className={styles.body}>
          <h2 className={styles.title}>Candidate Registration</h2>
          <p className={styles.sub}>Please verify that your details are correct. These will appear on your assessment report.</p>

          <div className={styles.fields}>
            <div className={styles.field}>
              <label className={styles.label}>Full Name</label>
              <div className={styles.readonlyField}>{candidate?.fullName}</div>
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Email Address</label>
              <div className={styles.readonlyField}>{candidate?.email}</div>
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Role Applied For</label>
              <div className={styles.readonlyField}>{displayRole}</div>
            </div>
          </div>

          <div className={styles.confirmRow}>
            <input type="checkbox" id="confirm" checked={confirmed} onChange={e => setConfirmed(e.target.checked)} className={styles.checkbox} />
            <label htmlFor="confirm" className={`${styles.confirmLabel} ${confirmed ? styles.confirmed : styles.pending}`}>I confirm that the above details are accurate.</label>
          </div>

          <button className={styles.btn} onClick={handleNext} disabled={!confirmed}>
            Next →
          </button>
        </div>

        <div className={styles.footer}>
          © {new Date().getFullYear()} UAC Foods Limited — Proprietary Assessment Tool. Unauthorized use prohibited.
        </div>
      </div>
    </div>
  );
}
